import classNames from 'classnames';
import React, { useEffect, useState } from 'react';

import MonetizationCard from '@src/components/MonetizationCard';
import ScaleGrowth from '@src/components/ScaleGrowth';
import UserGrowthCard from '@src/components/UserGrowthCard';

import './index.scss';

enum AnimationPhase {
  Initial = 'initial', // 初始状态
  ScaleGrowthCenter = 'scale-growth-center', // ScaleGrowth 在中间播放动画
  ScaleGrowthMove = 'scale-growth-move', // ScaleGrowth 移动到原位
  DescriptionShow = 'description-show', // 描述文字渐显
  CardsShow = 'cards-show', // 卡片从底部渐显
  CardsAnimate = 'cards-animate', // 卡片内部动画播放
}
interface ProductsProps {
  skipAnimation?: boolean;
}
const Products = (props: ProductsProps) => {
  const { skipAnimation } = props;
  const isMobile = typeof window !== 'undefined' && window.innerWidth <= 1180;
  const [phase, setPhase] = useState<AnimationPhase>(
    skipAnimation || isMobile ? AnimationPhase.CardsAnimate : AnimationPhase.Initial,
  );

  useEffect(() => {
    if (skipAnimation || isMobile) {
      setPhase(AnimationPhase.CardsAnimate);
      return;
    }
    const timeline = [
      { phase: AnimationPhase.ScaleGrowthCenter, delay: 100 },
      { phase: AnimationPhase.ScaleGrowthMove, delay: 3500 }, // ScaleGrowth 动画结束后
      { phase: AnimationPhase.DescriptionShow, delay: 3700 }, // 移动完成后
      { phase: AnimationPhase.CardsShow, delay: 3800 }, // 描述渐显后
      { phase: AnimationPhase.CardsAnimate, delay: 3850 }, // 卡片出现后
    ];

    const timers = timeline.map(({ phase, delay }) =>
      setTimeout(() => setPhase(phase), delay),
    );

    return () => timers.forEach(clearTimeout);
  }, [skipAnimation, isMobile]);
  return (
    <div className={classNames('odc-page-products', `phase-${phase}`)}>
      <div className="scale-growth-section">
        <ScaleGrowth animationEnabled={phase === AnimationPhase.ScaleGrowthCenter} skipAnimation={skipAnimation} />
        <div className={classNames('scale-growth-description')}>{'Proven and built by Miniclip, one of the world\'s biggest developers and publishers of mobile games'}</div>
      </div>
      <div className={classNames('platform-card-section', { 'visible': phase === AnimationPhase.CardsShow || phase === AnimationPhase.CardsAnimate })}>
        <UserGrowthCard animationEnabled={phase === AnimationPhase.CardsAnimate} skipAnimation={skipAnimation} />
        <MonetizationCard animationEnabled={phase === AnimationPhase.CardsAnimate} skipAnimation={skipAnimation} />
      </div>
    </div>
  );
};

export default Products;